module.exports = __webpack_public_path__ + "static/img/left-navigation-logo-icon.0c1581f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/prism/images/left-navigation-logo-icon.svg
// module id = ltqB
// module chunks = 73